import type {RouteRecordRaw} from "vue-router";

export const routeName = 'ServicesMobile';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'services',
    component: () => import('@/pages/CabinetService'),
    meta: {
        isHide: true,
        // Открыто гостям: на мобиле это меню со входом, сюда гард и отправляет
        requiresAuth: false,
    }
};
